import './lib/installFetchBypassForDashboardApis'
import React from 'react'
import ReactDOM from 'react-dom/client'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import AppWithInitialData from './AppWithInitialData'
import { store } from './app/store'
import { Provider } from 'react-redux'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import './i18n'
import 'dayjs/locale/es'
import 'dayjs/locale/pt-br'
import 'dayjs/locale/en'
import { Auth0Provider } from '@auth0/auth0-react'

dayjs.extend(utc)
dayjs.extend(customParseFormat)

let persistor = persistStore(store)

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_API_BASE_URL}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      responseType="code"
    >
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <AppWithInitialData />
        </PersistGate>
      </Provider>
    </Auth0Provider>
  </React.StrictMode>,
)
